import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { EditGroupRequest } from '../api/group/editgrop/editgrouprequest';
import { EditGroupResponse, EditGroupResponseDtoImpl } from '../api/group/editgrop/editgroupresponse';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { SixdeeCRBTAPIProcessor } from './sixdeecrbtapiprocessor';
import { Strings } from '../../utils/resources/strings';

export class EditGroupAPIProcessorImpl extends SixdeeCRBTAPIProcessor<EditGroupRequest, EditGroupResponse>
{
    execute(request: EditGroupRequest): void {
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        try 
        {
            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS)
             {
                let response = new EditGroupResponseDtoImpl(APIFeatures.EDIT_GROUP, "Edit Group Success");

                this.getAPISuccess(response);
            }
        }
        catch (e)
        {
            this.getAPIFailure(new EditGroupResponseDtoImpl(APIFeatures.EDIT_GROUP, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
        super.onFailure(responseMapper);
    
            this.getAPIFailure(new EditGroupResponseDtoImpl(APIFeatures.EDIT_GROUP, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/editgroupapiprocessor.tsx